import { MapfreLoadingComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges , NO_ERRORS_SCHEMA } from '@angular/core';
import { FormGroup, FormControl, Validators , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { PhoneFormatter } from '../../../../../../_helpers/_formatters/phone-formatter';

import { UserDataService } from '../../../../../../_services/data-services/user-data.service';
import { PolicyDataService } from '../../../../../../_services/data-services/policy-data.service';
import { FullStateToAbvHelper } from '../../../../../../_helpers/fullstate-to-abv.service';
import { RegExHelper, 
  GetGooglePlaceService,
  ValidateAddressService} from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbFormsModule, MapfreLoadingComponent],
  selector: 'app-refund-selected-reason',
  templateUrl: './refund-selected-reason.component.html',
  styleUrls: ['./refund-selected-reason.component.scss']
})
export class RefundSelectedReasonComponent implements OnInit, OnChanges {
  @Input() policyNumber: string;
  @Input() typeOfReason: string;
  @Output() isSubmitActive: EventEmitter<boolean> = new EventEmitter<boolean>();

  formGroup: FormGroup;
  userDetails: any = {};
  states: any[];
  policy: any = {};
  loading: boolean;
  isDigitalRefund: boolean;
  reasonValue = '';

  showMailingAddressEditFields = false;
  showEmailEditField = false;
  showPhoneEditField = false;

  showStreetError = false;
  showCityError = false;
  showZipCodeError = false;
  showStateError = false;
  showPhoneError = false;
  showEmailError = false;
  invalidMailingAddress: boolean;

  emailPattern: RegExp;

  constructor(
    private userDataService: UserDataService,
    private policyDataService: PolicyDataService,
    private stateHelper: FullStateToAbvHelper,
    private phoneFormater: PhoneFormatter,
    private regExHelper: RegExHelper,
    private getGooglePlaceService: GetGooglePlaceService,
    private validateAddressService: ValidateAddressService,
  ) {  
    this.emailPattern = this.regExHelper.looseEmailPattern;
    this.invalidMailingAddress = false;
   }

  ngOnInit(): void {
    this.loading = true;
    this.formGroup = new FormGroup({
      isDigitalRefund: new FormControl(null)
    });

    this.formGroup.get('isDigitalRefund')?.
      valueChanges.subscribe(value => {
        this.isDigitalRefund = value;
        this.toggleSubmitButton(true);
      });

    this.setUserData();
    this.setPolicyData();
  }
  ngOnChanges(): void {
    if(this.typeOfReason !== this.reasonValue) {
      if(this.isDigitalRefund !== null && this.isDigitalRefund !== undefined){
        this.formGroup.get('isDigitalRefund').patchValue(null);
      }
      this.reasonValue = this.typeOfReason;
    }
  }

  setPolicyData(){
    this.states = this.stateHelper.getStates().map( state => {
      return {
        ...state,
        disabled: false
      }
    });
    this.states.unshift({
        fullStateName: 'State',
        abv: 'State',
        disabled: true
    })
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse) {
        this.policy = policyResponse
                        .find(policyDetails => policyDetails.policynumber.policyNumber === this.policyNumber);
        if(this.policy?.mailingAddress){
          this.userDetails.mailingAddress = this.policy?.mailingAddress
          this.userDetails.updatedMailingAddress = this.policy?.mailingAddress
        }

        const primaryInsured = this.policy.insured?.find(insured => insured.isPrimaryInsured);
        this.userDetails.primaryInsuredName = primaryInsured.insuredFullName;
        this.userDetails.secondInsuredName = this.policy.insured
                        ?.find(insured => !insured.isPrimaryInsured)?.insuredFullName;
      }
      this.loading = false;
    });
  }

  setUserData() {
    this.userDataService.$userData.subscribe((user) => {
      if (user && user.userDetails) {
        this.userDetails.email = user.userDetails.email?.address;
        this.userDetails.updatedEmail = this.userDetails.email;

        this.userDetails.phoneNumber = this.getPrimaryPhone(user.userDetails.phoneList);
        this.userDetails.updatedPhoneNumber = this.userDetails.phoneNumber;
      }
    });
  }

  getPrimaryPhone(phoneList): string {
    const phone = phoneList && phoneList.find((phone) => phone.primary);
    if (phone && phone.number) {
      return this.phoneFormater.format(phone.number);
    }
    return '';
  }

  showEditField(fieldName: string){
    if(fieldName === 'email'){
      this.showEmailEditField = true;
      this.formGroup.addControl('email', new FormControl('', [
        Validators.required,
        Validators.pattern(this.emailPattern)
      ]));
    } else if(fieldName === 'phone'){
      this.showPhoneEditField = true;
      this.formGroup.addControl('phone', new FormControl('', [
        Validators.required,
        Validators.minLength(12)
      ]));
    } else{
      this.showMailingAddressEditFields = true;

      this.formGroup.addControl('street', new FormControl('', [ Validators.required ]));
      this.formGroup.addControl('city', new FormControl('', [ Validators.required ]));
      this.formGroup.addControl('state', new FormControl(null, [ Validators.required ]));
      this.formGroup.addControl('zipCode', new FormControl('', [ 
        Validators.required,
        Validators.pattern(/^[0-9]{5}$/)
      ]));
    }
  }
  
  clearError(key: string) {
    if(key === 'street'){
      this.showStreetError = false;
    } else if(key === 'city'){
      this.showCityError = false;
    } else if(key === 'zipCode'){
      this.showZipCodeError = false;
    } else if(key === 'state'){
      this.showStateError = false;
      this.showZipCodeError = false;
    } else if(key === 'phone'){
      this.showPhoneError = false;
    } else {
      this.showEmailError = false;
    } 

    this.toggleSubmitButton(true);
  }

  resetEditingEmail() {
    this.showEmailEditField = false;
    this.showEmailError = false;
    this.formGroup.removeControl('email');
    this.toggleSubmitButton(this.showEmailError);
  }

  resetEditingPhone() {
    this.showPhoneEditField = false;
    this.showPhoneError = false;
    this.formGroup.removeControl('phone');
    this.toggleSubmitButton(this.showEmailError);
  }

  resetMailingAddress(){
    this.showMailingAddressEditFields = false;
    this.showStreetError = false;
    this.showCityError = false;
    this.showZipCodeError = false;
    this.showStateError = false;

    this.formGroup.removeControl('street');
    this.formGroup.removeControl('city');
    this.formGroup.removeControl('state');
    this.formGroup.removeControl('zipCode');
    this.toggleSubmitButton(this.showEmailError);
  }

  isValid(key) {
    return this.formGroup.get(key)?.valid; 
  }
  
  toggleSubmitButton(flag) {
    void flag;
    if(this.isDigitalRefund){
      const isEditingPhone = this.showPhoneEditField && this.formGroup.get('phone')?.value;
      const isEditingEmail = this.showEmailEditField && this.formGroup.get('email')?.value;
      
      this.isSubmitActive.emit(!isEditingPhone && !isEditingEmail);
    } else {
      const isEditingMailingAdd = this.showMailingAddressEditFields 
                && (this.formGroup.get('street')?.value || this.formGroup.get('state')?.value
                    || this.formGroup.get('zipCode')?.value || this.formGroup.get('city')?.value)
      this.isSubmitActive.emit(!isEditingMailingAdd);
    }
  }

  emailValidationOnBlur() {
    this.showEmailError = this.isValid('email') ? false : true;
    this.toggleSubmitButton(this.showEmailError);
  }
  saveEditedEmail() {
    if (this.isValid('email')) {
      this.userDetails.updatedEmail = this.formGroup.get('email')?.value;
      this.resetEditingEmail();
    } else {
      this.showEmailError = true;
    }
    this.toggleSubmitButton(this.showEmailError);
  }
  phoneValidationOnBlur() {
    this.showPhoneError = this.isValid('phone') ? false : true; 
    this.toggleSubmitButton(this.showPhoneError);
  }
  saveEditedPhone(){
    if (this.isValid('phone')) {
      this.userDetails.updatedPhoneNumber = this.formGroup.get('phone')?.value;
      this.resetEditingPhone();
    } else {
      this.showPhoneError = true;
      this.toggleSubmitButton(this.showPhoneError);
    }
  }

  isValidInput(errorKey, inputFormKey) {
      this[`show${errorKey}Error`] = this.formGroup.get(inputFormKey)?.invalid;
      this.toggleSubmitButton(this[`show${errorKey}Error`]);
  }
  saveMailingAddress() {
    this.toggleSubmitButton(true);
    this.invalidMailingAddress = true;
    if (this.formGroup.get('street')?.invalid) {
      this.showStreetError = true;
    } 
    if (this.formGroup.get('city')?.invalid) {
      this.showCityError = true;
    } 
    if (this.formGroup.get('state')?.invalid) {
      this.showStateError = true;
    } 
    if (this.formGroup.get('zipCode')?.invalid) {
      this.showZipCodeError = true;
    } 

    const isAddressValid = !this.showZipCodeError && !this.showStateError 
                                && !this.showCityError && !this.showStreetError;
    if(isAddressValid) {
      this.validateAddressService
        .validateZipCodeStateMatch(this.formGroup.get('zipCode')?.value, this.formGroup.get('state')?.value)
        .subscribe(isMatch => {
            if(isMatch){
              this.invalidMailingAddress = false;
              this.userDetails.updatedMailingAddress = {
                streetName: this.formGroup.get('street')?.value,
                city: this.formGroup.get('city')?.value,
                stateCode: this.formGroup.get('state')?.value,
                zipCode: { code: this.formGroup.get('zipCode')?.value }
              };
              this.resetMailingAddress();
            }
            this.showZipCodeError = !isMatch;
          },
          error => {
            console.error(error);
            this.showZipCodeError = true;
          }
      );
    }
  }

  getDataToSubmit(){
    const addProperties: any = {digitalRefund: this.isDigitalRefund};
    if(this.isDigitalRefund){
      addProperties.email = this.userDetails.email;
      if(this.userDetails.email !== this.userDetails.updatedEmail){
        addProperties.updatedEmail = this.userDetails.updatedEmail;
      }
      addProperties.phoneNumber = this.userDetails.phoneNumber;
      if(this.userDetails.phoneNumber !== this.userDetails.updatedPhoneNumber){
        addProperties.updatedPhoneNumber = this.userDetails.updatedPhoneNumber;
      }
    }else{
      addProperties.mailingAddRow1 = this.userDetails.mailingAddress.streetName;
      addProperties.mailingAddRow2 = this.userDetails.mailingAddress.city 
                            + ', ' + this.userDetails.mailingAddress.stateCode 
                            + ' ' + this.userDetails.mailingAddress.zipCode.code;

      const updatedMailingAddRow1 = this.userDetails.updatedMailingAddress.streetName;
      const updatedMailingAddRow2 = this.userDetails.updatedMailingAddress.city 
                            + ', ' + this.userDetails.updatedMailingAddress.stateCode 
                            + ' ' + this.userDetails.updatedMailingAddress.zipCode.code;

      if(addProperties.mailingAddRow1 !== updatedMailingAddRow1 
              || addProperties.mailingAddRow2 !== updatedMailingAddRow2){
        addProperties.updatedMailingAddRow1 = updatedMailingAddRow1;
        addProperties.updatedMailingAddRow2 = updatedMailingAddRow2;
      }
    }
    return {addProperties};
  }

}
